export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-tag-group/index.js